import { useSaved } from "../hooks/useSaved";
import { Link } from "react-router-dom";
import LazyImage from "../components/LazyImage";
import { Heart, X } from "lucide-react";

export default function Saved() {
    const { saved, toggle } = useSaved();
    return (
        <main data-testid="saved-page" className="bg-black min-h-screen pt-32 pb-24">
            <div className="container-luxury">
                <div className="overline mb-4">Your Inspirations</div>
                <h1 className="font-serif text-5xl sm:text-6xl tracking-tight mb-12">Saved collection.</h1>

                {saved.length === 0 ? (
                    <div className="text-center py-32 text-white/50" data-testid="saved-empty">
                        <Heart size={32} className="mx-auto mb-6 text-gold/60" strokeWidth={1.2} />
                        <div className="font-serif text-3xl mb-3">No inspirations yet.</div>
                        <p className="text-sm mb-8">Tap the heart on any project to start your mood board.</p>
                        <Link to="/explore" className="btn-gold">Browse projects</Link>
                    </div>
                ) : (
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="saved-grid">
                        {saved.map((p) => (
                            <div key={p.id} className="relative group">
                                <Link to={`/projects/${p.slug}`} className="block aspect-[4/5] overflow-hidden">
                                    <LazyImage src={p.thumbnail_url} className="w-full h-full" />
                                </Link>
                                <div className="mt-3">
                                    <div className="overline text-gold/70 mb-1">{p.room_type} · {p.company_name}</div>
                                    <div className="font-serif text-lg leading-tight">{p.title}</div>
                                </div>
                                <button
                                    onClick={() => toggle(p)}
                                    className="absolute top-3 right-3 p-2 glass text-gold hover:text-white"
                                    data-testid={`saved-remove-${p.slug}`}
                                >
                                    <X size={14} />
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </main>
    );
}
